// extracted by mini-css-extract-plugin
export default {"monthWrapper":"Month_monthWrapper__a+OkF","week":"Month_week__9P+xH"};